import { render, staticRenderFns } from "./employeePanel.vue?vue&type=template&id=37566c7a"
import script from "./employeePanel.vue?vue&type=script&lang=js"
export * from "./employeePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports